export interface Segment {
  id: string;
  name: string;
  // Les volumes peuvent être absents pour les segments provenant uniquement de l'API
  volumes?: {
    '30': {
      email: number;
      mobile: number;
      emailOrMobile: number;
      emailAndMobile: number;
    };
    '60': {
      email: number;
      mobile: number;
      emailOrMobile: number;
      emailAndMobile: number;
    };
    '90': {
      email: number;
      mobile: number;
      emailOrMobile: number;
      emailAndMobile: number;
    };
  };
}

export interface Category {
  id: string;
  name: string;
  segments: Segment[];
}

import { OutputFormat } from '@/constants/outputFormat';

export interface Order {
  id: string;
  requestName: string;
  volume: number;
  price: number;
  date: string;
  owner: string;
  status: 'NEW_REQUEST' | 'QUOTE_REQUESTED' | 'RUNNING' | 'SUCCESS' | 'ERROR';
  type: 'Email' | 'Mobile' | 'CRM ID';
  // id_type brut de l'API : 'emails' | 'phones' | 'emails OR phones' | 'emails AND phones'
  idType?: string;
  resultUrl?: string;
  selectedSegments?: Array<{ categoryName: string; segmentName: string; segmentId: string }>;
  duration?: '30' | '60' | '90';
  selectedCrm?: string;
  crmExclusion?: string[];
  outputFormat?: OutputFormat;
  // Détail par population (cf. contract.md §3) ; absent si demande sans population.
  populationRequests?: Array<{
    population: string;
    type: 'Email' | 'Mobile' | 'CRM ID';
    // id_type brut de l'API : 'emails' | 'phones' | 'emails OR phones' | 'emails AND phones'
    idType: string;
    volume: number;
  }>;
}

export const mockCategories: Category[] = [
  {
    id: 'cat1',
    name: 'Retail & E-commerce',
    segments: [
      {
        id: 'seg1',
        name: 'Fashion Enthusiasts',
      },
      {
        id: 'seg2',
        name: 'Home & Garden Shoppers',
      },
      {
        id: 'seg3',
        name: 'Electronics Buyers',
      }
    ]
  },
  {
    id: 'cat2',
    name: 'Finance & Banking',
    segments: [
      {
        id: 'seg4',
        name: 'Investment Seekers',
      },
      {
        id: 'seg5',
        name: 'Credit Card Users',
      },
      {
        id: 'seg6',
        name: 'SME Business Owners',
      }
    ]
  },
  {
    id: 'cat3',
    name: 'Travel & Hospitality',
    segments: [
      {
        id: 'seg7',
        name: 'Luxury Travelers',
      },
      {
        id: 'seg8',
        name: 'Business Travelers',
      },
      {
        id: 'seg9',
        name: 'Family Vacation Planners',
      }
    ]
  },
  {
    id: 'cat4',
    name: 'Health & Wellness',
    segments: [
      {
        id: 'seg10',
        name: 'Fitness Enthusiasts',
      },
      {
        id: 'seg11',
        name: 'Nutrition Focused',
      }
    ]
  },
  {
    id: 'cat5',
    name: 'Automobile',
    segments: [
      {
        id: 'seg12',
        name: 'SUV',
      },
      {
        id: 'seg13',
        name: 'Electrique',
      },
      {
        id: 'seg14',
        name: 'Luxe',
      }
    ]
  },
  {
    id: 'cat6',
    name: 'Sport',
    segments: [
      {
        id: 'seg15',
        name: 'Football',
      },
      {
        id: 'seg16',
        name: 'Tennis',
      },
      {
        id: 'seg17',
        name: 'Basketball',
      }
    ]
  },
  {
    id: 'cat7',
    name: 'News',
    segments: [
      {
        id: 'seg18',
        name: 'Actualités générales',
      },
      {
        id: 'seg19',
        name: 'Technologie',
      },
      {
        id: 'seg20',
        name: 'Politique',
      }
    ]
  },
  {
    id: 'cat8',
    name: 'Activité Maison',
    segments: [
      {
        id: 'seg21',
        name: 'Chaine télé',
      },
      {
        id: 'seg22',
        name: 'Jeux Vidéo',
      },
      {
        id: 'seg23',
        name: 'Comics',
      },
      {
        id: 'seg24',
        name: 'Paris',
      },
      {
        id: 'seg25',
        name: 'Film',
      }
    ]
  },
  {
    id: 'cat9',
    name: 'DIY',
    segments: [
      {
        id: 'seg26',
        name: 'DIY',
      },
      {
        id: 'seg27',
        name: 'Culture Maker',
      },
      {
        id: 'seg28',
        name: 'Maker Culture',
      }
    ]
  },
  {
    id: 'cat10',
    name: 'Mobilité',
    segments: [
      {
        id: 'seg29',
        name: 'Air Transport',
      },
      {
        id: 'seg30',
        name: 'Rail Transport',
      },
      {
        id: 'seg31',
        name: 'Eco mobilité',
      }
    ]
  },
  {
    id: 'cat11',
    name: 'Family',
    segments: [
      {
        id: 'seg32',
        name: 'Pets',
      },
      {
        id: 'seg33',
        name: 'Family',
      },
      {
        id: 'seg34',
        name: 'Cats',
      },
      {
        id: 'seg35',
        name: 'Children',
      }
    ]
  },
  {
    id: 'cat12',
    name: 'Academics',
    segments: [
      {
        id: 'seg36',
        name: 'Geometry',
      },
      {
        id: 'seg37',
        name: 'Language',
      },
      {
        id: 'seg38',
        name: 'Classical music & instruments',
      },
      {
        id: 'seg39',
        name: 'Literature',
      },
      {
        id: 'seg40',
        name: 'Astronomy',
      }
    ]
  }
];

export const mockOrders: Order[] = [
  {
    id: 'ORD001',
    requestName: 'Campagne Mode Automne',
    volume: 5000,
    price: 750,
    date: '2025-03-15',
    owner: 'marie.dubois@company.com',
    status: 'SUCCESS',
    type: 'Email',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD001.csv',
    selectedSegments: [
      { categoryName: 'Retail & E-commerce', segmentName: 'Fashion Enthusiasts', segmentId: 'seg1' },
      { categoryName: 'Retail & E-commerce', segmentName: 'Electronics Buyers', segmentId: 'seg3' },
      { categoryName: 'Health & Wellness', segmentName: 'Fitness Enthusiasts', segmentId: 'seg10' }
    ],
    duration: '30',
    selectedCrm: 'CRM-001'
  },
  {
    id: 'ORD002',
    requestName: 'Promo Investissement Q1',
    volume: 3200,
    price: 480,
    date: '2025-04-22',
    owner: 'pierre.martin@finance.com',
    status: 'SUCCESS',
    type: 'Mobile',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD002.csv',
    selectedSegments: [
      { categoryName: 'Finance & Banking', segmentName: 'Investment Seekers', segmentId: 'seg4' },
      { categoryName: 'Finance & Banking', segmentName: 'Credit Card Users', segmentId: 'seg5' },
      { categoryName: 'Travel & Hospitality', segmentName: 'Business Travelers', segmentId: 'seg8' }
    ],
    duration: '60',
    selectedCrm: 'CRM-002'
  },
  {
    id: 'ORD003',
    requestName: 'Electronics Black Friday',
    volume: 7500,
    price: 1125,
    date: '2025-09-28',
    owner: 'sophie.leroy@tech.com',
    status: 'RUNNING',
    type: 'Email',
    selectedSegments: [
      { categoryName: 'Retail & E-commerce', segmentName: 'Electronics Buyers', segmentId: 'seg3' },
      { categoryName: 'News', segmentName: 'Technologie', segmentId: 'seg19' }
    ],
    duration: '30',
    selectedCrm: 'CRM-006'
  },
  {
    id: 'ORD004',
    requestName: 'Voyage Premium Été',
    volume: 2100,
    price: 315,
    date: '2025-06-10',
    owner: 'jean.petit@travel.com',
    status: 'SUCCESS',
    type: 'CRM ID',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD004.csv',
    selectedSegments: [
      { categoryName: 'Travel & Hospitality', segmentName: 'Luxury Travelers', segmentId: 'seg7' },
      { categoryName: 'Travel & Hospitality', segmentName: 'Business Travelers', segmentId: 'seg8' }
    ],
    duration: '90',
    selectedCrm: 'CRM-003'
  },
  {
    id: 'ORD005',
    requestName: 'Business Travel Q4',
    volume: 4800,
    price: 720,
    date: '2025-07-05',
    owner: 'anna.rodriguez@corp.com',
    status: 'ERROR',
    type: 'Email',
    selectedSegments: [
      { categoryName: 'Travel & Hospitality', segmentName: 'Business Travelers', segmentId: 'seg8' },
      { categoryName: 'Mobilité', segmentName: 'Air Transport', segmentId: 'seg29' }
    ],
    duration: '60',
    selectedCrm: 'CRM-007'
  },
  {
    id: 'ORD006',
    requestName: 'Fitness Challenge 2024',
    volume: 6200,
    price: 930,
    date: '2025-08-12',
    owner: 'lucas.bernard@fitness.com',
    status: 'QUOTE_REQUESTED',
    type: 'Email',
    selectedSegments: [
      { categoryName: 'Health & Wellness', segmentName: 'Fitness Enthusiasts', segmentId: 'seg10' },
      { categoryName: 'Health & Wellness', segmentName: 'Nutrition Focused', segmentId: 'seg11' },
      { categoryName: 'Sport', segmentName: 'Football', segmentId: 'seg15' }
    ],
    duration: '90',
    selectedCrm: 'CRM-008'
  },
  {
    id: 'ORD007',
    requestName: 'Credit Card Promo',
    volume: 3900,
    price: 585,
    date: '2025-09-20',
    owner: 'emma.moreau@bank.com',
    status: 'SUCCESS',
    type: 'Mobile',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD007.csv',
    selectedSegments: [
      { categoryName: 'Finance & Banking', segmentName: 'Credit Card Users', segmentId: 'seg5' }
    ],
    duration: '30',
    selectedCrm: 'CRM-004'
  },
  {
    id: 'ORD008',
    requestName: 'Jardin Printemps',
    volume: 5500,
    price: 825,
    date: '2025-09-30',
    owner: 'thomas.laurent@garden.com',
    status: 'RUNNING',
    type: 'Email',
    selectedSegments: [
      { categoryName: 'Retail & E-commerce', segmentName: 'Home & Garden Shoppers', segmentId: 'seg2' },
      { categoryName: 'DIY', segmentName: 'DIY', segmentId: 'seg26' }
    ],
    duration: '30',
    selectedCrm: 'CRM-009'
  },
  {
    id: 'ORD009',
    requestName: 'Vacances Famille Été',
    volume: 4100,
    price: 615,
    date: '2025-01-08',
    owner: 'julie.simon@family.com',
    status: 'SUCCESS',
    type: 'CRM ID',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD009.csv',
    selectedSegments: [
      { categoryName: 'Travel & Hospitality', segmentName: 'Family Vacation Planners', segmentId: 'seg9' },
      { categoryName: 'Family', segmentName: 'Family', segmentId: 'seg33' },
      { categoryName: 'Family', segmentName: 'Children', segmentId: 'seg35' }
    ],
    duration: '60',
    selectedCrm: 'CRM-010'
  },
  {
    id: 'ORD010',
    requestName: 'Nutrition Bio',
    volume: 2800,
    price: 420,
    date: '2025-02-16',
    owner: 'marc.dupont@health.com',
    status: 'SUCCESS',
    type: 'Mobile',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD010.csv',
    selectedSegments: [
      { categoryName: 'Health & Wellness', segmentName: 'Nutrition Focused', segmentId: 'seg11' }
    ],
    duration: '30',
    selectedCrm: 'CRM-011'
  },
  {
    id: 'ORD011',
    requestName: 'PME Solutions',
    volume: 1900,
    price: 285,
    date: '2025-07-18',
    owner: 'sarah.michel@business.com',
    status: 'QUOTE_REQUESTED',
    type: 'Email',
    selectedSegments: [
      { categoryName: 'Finance & Banking', segmentName: 'SME Business Owners', segmentId: 'seg6' },
      { categoryName: 'News', segmentName: 'Actualités générales', segmentId: 'seg18' }
    ],
    duration: '30',
    selectedCrm: 'CRM-012'
  },
  {
    id: 'ORD012',
    requestName: 'Mode Hiver Collection',
    volume: 6800,
    price: 1020,
    date: '2025-04-30',
    owner: 'david.garcia@fashion.com',
    status: 'SUCCESS',
    type: 'CRM ID',
    resultUrl: 'https://storage.googleapis.com/bucket/results/ORD012.csv',
    selectedSegments: [
      { categoryName: 'Retail & E-commerce', segmentName: 'Fashion Enthusiasts', segmentId: 'seg1' },
      { categoryName: 'Retail & E-commerce', segmentName: 'Home & Garden Shoppers', segmentId: 'seg2' },
      { categoryName: 'Retail & E-commerce', segmentName: 'Electronics Buyers', segmentId: 'seg3' },
      { categoryName: 'Sport', segmentName: 'Football', segmentId: 'seg15' },
      { categoryName: 'Sport', segmentName: 'Tennis', segmentId: 'seg16' }
    ],
    duration: '60',
    selectedCrm: 'CRM-005'
  }
];